
import { Component, Prop, Vue } from "vue-property-decorator";

export interface CustomsDeclarationPreviewItem {
  hsCode?: string;
  declarationName?: string;
  weightOrQuantity?: number;
  unit?: string;
  unitPrice?: number;
  totalPrice?: number;
  originCountry?: string;
  destinationCountry?: string;
  sourcePlace?: string;
  currencies?: string[];
}

@Component({
  name: "CustomsDeclarationPreviewDialog",
})
export default class extends Vue {
  @Prop({ default: false }) private visible!: boolean;
  @Prop({ default: () => [] }) private items!: CustomsDeclarationPreviewItem[];
  @Prop({ default: false }) private loading!: boolean;

  get itemCount(): number {
    return (this.items || []).length;
  }

  private getCurrencies(row: CustomsDeclarationPreviewItem): string[] {
    return (row.currencies || []).filter((c) => !!c);
  }

  private hasMultipleCurrencies(row: CustomsDeclarationPreviewItem): boolean {
    return this.getCurrencies(row).length > 1;
  }

  private multiCurrencyTip(row: CustomsDeclarationPreviewItem): string {
    return `存在多个币种：${this.getCurrencies(row).join("、")}`;
  }

  private currencySymbol(currency?: string): string {
    const code = (currency || "").toUpperCase();
    if (code === "USD") {
      return "$";
    }
    if (code === "EURO" || code === "EUR") {
      return "€";
    }
    if (code === "CNY" || code === "RMB" || code === "￥" || code === "¥") {
      return "￥";
    }
    return currency || "";
  }

  private formatPriceWithCurrency(
    row: CustomsDeclarationPreviewItem,
    value?: number | string
  ): string {
    if (value == null || value === "") {
      return "";
    }
    const currencies = this.getCurrencies(row);
    if (currencies.length === 1) {
      return `${this.currencySymbol(currencies[0])}${value}`;
    }
    return String(value);
  }

  private handleClose() {
    this.$emit("update:visible", false);
  }
}
